import { get, post } from '../../../util/api'
import * as type from './type'
import * as selector from './selector'
import { enrichLead, enrichLeadList } from './enrich-lead'
import { createChangeTableSettingAction } from '../../form/state/table-state-helper'

export const changeTableSetting = createChangeTableSettingAction(type.CHANGE_TABLE_SETTING)


export const findAllLeadRequest = () => ({
    type: type.FIND_ALL_LEAD_REQUEST,
    payload: {},
})

export const findAllLeadSuccess = (leadList) => ({
    type: type.FIND_ALL_LEAD_SUCCESS,
    payload: {
        leadList,
    },
})

export const findAllLeadError = (error) => ({
    type: type.FIND_ALL_LEAD_ERROR,
    payload: {
        error,
    },
})


export const findAllLead = () => (dispatch, getState) => {
    dispatch(findAllLeadRequest())

    get('/api/lead/find-all-not-archived')
        .then(leadList => {
            enrichLeadList(getState(), leadList)
            dispatch(findAllLeadSuccess(leadList))
        })
        .catch(error => {
            dispatch(findAllLeadError(error))
        })
}

export const findAllLeadIfNotLoaded = () => (dispatch, getState) => {
    // return;
    // let leadList = selector.selectLeadList(getState());
    // if (leadList.length === 0) {
    //     dispatch(findAllLead());
    // }
}


export const findLeadRequest = (leadId) => ({
    type: type.FIND_LEAD_REQUEST,
    payload: {
        leadId,
    },
})

export const findLeadSuccess = (lead) => ({
    type: type.FIND_LEAD_SUCCESS,
    payload: {
        lead,
    },
})

export const findLeadError = (error) => ({
    type: type.FIND_LEAD_ERROR,
    payload: {
        error,
    },
})


export const findLead = (leadId) => (dispatch, getState) => {
    dispatch(findLeadRequest(leadId))

    get('/api/lead/find-by-id?leadId=' + leadId)
        .then(lead => {
            enrichLead(getState(), lead)
            dispatch(findLeadSuccess(lead))
        })
        .catch(error => {
            dispatch(findLeadError(error))
        })
}

export const changeLead = (name, value) => ({
    type: type.CHANGE_LEAD,
    payload: {
        name,
        value,
    },
})

export const saveLeadRequest = () => ({
    type: type.SAVE_LEAD_REQUEST,
})

export const saveLeadSuccess = (lead) => ({
    type: type.SAVE_LEAD_SUCCESS,
    payload: {
        lead,
    },
})

export const saveLeadError = (error) => ({
    type: type.SAVE_LEAD_ERROR,
    payload: {
        error,
    },
})

export const saveLead = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    const lead = selector.selectLead(state)
    dispatch(saveLeadRequest())
    post('/api/lead/save', lead)
        .then(lead => {
            enrichLead(state, lead)
            dispatch(saveLeadSuccess(lead))
        })
        .catch(error => {
            dispatch(saveLeadError(error))
        })
}

export const addSentEmail = (sentEmail) => ({
    type: type.ADD_SENT_EMAIL,
    payload: {
        sentEmail,
    },
})




// WEBPACK FOOTER //
// ./src/modules/lead/state/action.js